.bx{border:1px solid #ddd;}